import { Component, OnInit, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { DsSwitch } from '@frontend/ui/switch';
import { LoginConfig } from '@frontend/vanilla/shared/login';

import { LoginContentService } from './login-content.service';
import { LoginTrackingService } from './login-tracking.service';

@Component({
    selector: 'lh-prefill-username-toggle',
    templateUrl: 'prefill-username-toggle.component.html',
    imports: [DsSwitch],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: PrefillUsernameToggleComponent,
            multi: true,
        },
    ],
})
export class PrefillUsernameToggleComponent implements ControlValueAccessor, OnInit {
    isDisabled: boolean = false;
    private innerValue: boolean;

    readonly loginContentService = inject(LoginContentService);
    readonly loginConfig = inject(LoginConfig);
    private readonly trackingService = inject(LoginTrackingService);

    get v2(): boolean {
        return this.loginConfig.v2;
    }

    get value(): boolean {
        return this.innerValue;
    }

    set value(value: boolean) {
        if (this.innerValue !== value) {
            this.innerValue = value;
            this.onChange(this.innerValue);
        }
    }

    ngOnInit() {
        this.trackingService.trackPrefillUsernameLoaded();
    }

    onChange: (_: any) => void = () => {};
    onTouched = () => {};

    writeValue(value: boolean) {
        if (value !== this.value) {
            this.value = value;
        }
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean) {
        this.isDisabled = isDisabled;
    }

    togglePrefill(value: boolean) {
        this.value = value;
        this.trackingService.trackPrefillUsernameClicked(value);
    }

    changePrefill(event: Event) {
        if (event.target instanceof HTMLInputElement) {
            this.togglePrefill(event.target.checked);
        }
    }
}
